import React, { useEffect, useState }               from 'react';
import { useSelector }                              from 'react-redux';
import { Button }                                   from 'react-bootstrap';

import clienteAxios                                 from '../../../../config/axios';

import AccusedResultInfo                            from '../info/items/AccusedResultInfo';
import { AGENDADA }                                 from '../../../../data/audienceStates';
import AuthoritiesService                           from '../../../../services/AuthoritiesService';
import { ErrorMessage, SuccessMessage }             from '../../../extras/toastMessages';
import { ICON_ACCUSED, ICON_REMOVE, ICON_SEARCH }   from '../../../extras/icons';
import { MSG_ERROR_SERVER }                         from '../../../../constants/messages';
import { MSG_ANULATE_ACCUSED_RESULT_SUCCESS  }      from '../../../../constants/messages';
import { RESULTADOS_CREAR }                         from '../../../../data/objects';
import StateAccusedResultForm                       from './forms/StateAccusedResultForm';
import Swal                                         from 'sweetalert2';



const AccusedListRow = props => {


    // --------------------------------------------------------------------------------------------
    // DECLARACIONES ------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    // Tomo los props
    const { accused, audience, tipos } = props;
    
    // Traigo el store
    const authorities = useSelector(state => state.auth.authorities);
    
    // Inicializo el state local
    const [selectedAccused, setAccused] = useState(accused);
    const [show, setShow] = useState(false);    
    const [showInfo, setShowInfo] = useState(false);


    // --------------------------------------------------------------------------------------------
    // FUNCIONES ----------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    // Manejo el modal del form
    const handleOpen = () => {
        setShow(true);
    }
    const handleClose = () => {
        setShow(false);
    }    

    // Manejo el modal de info
    const handleOpenInfo = () => {        
        setShowInfo(true);
    }
    const handleCloseInfo = () => {
        setShowInfo(false);
    }

    // Eliminar Resultados
    const handleRemoveResult = () => {
        Swal.fire({
            title: 'Eliminar Resultado?',
            text: 'La operación no se podrá revertir',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#e74a3b',
            confirmButtonText: 'Si, Eliminar'
        }).then((result) => {
            if(result.value)
            {   anulateAccusedResult(accused);
            }
        })        
    }
    const anulateAccusedResult = async (accused) => {
        try
        {   const response = await clienteAxios.put(`/imputado/delete-resultado/${accused.id}`);
            if(response.status===200)
            {   setAccused({   
                    ...accused,
                    resultado: null
                });
                SuccessMessage(MSG_ANULATE_ACCUSED_RESULT_SUCCESS);
            }
            else
            {   ErrorMessage(MSG_ERROR_SERVER);  
            }
        }
        catch(error)
        {   const response = error.response;
            let data = MSG_ERROR_SERVER
            if(response) data = response.data;
            ErrorMessage(data);
        }
    }

    //Refresca cuando cambia  el imputado
    useEffect(() => {
        setAccused(accused);
        // eslint-disable-next-line
    }, [accused])
    


    // --------------------------------------------------------------------------------------------
    // RENDERIZO ----------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    return (
        <tr key={`ata${selectedAccused.id}`}>
            <td className="align-middle text-center">
                { selectedAccused.persona.apellido + ', ' + selectedAccused.persona.nombre }
            </td>
            <td className="align-middle text-center">
                { selectedAccused.persona.tipoDocumento + ' ' + selectedAccused.persona.identificacion }
            </td>
            <td className="align-middle text-center">
                {   authorities && AuthoritiesService.hasPermission(authorities, RESULTADOS_CREAR) 
                        ?
                            audience.estado.id === AGENDADA 
                                ?
                                    !selectedAccused.resultado
                                        ?
                                            <Button key={selectedAccused.resultado?.length} variant="warning" size="sm" onClick={handleOpen}>
                                                <ICON_ACCUSED />
                                            </Button>
                                        :
                                            <>
                                                <Button key={selectedAccused.resultado?.length} variant="info" size="sm" onClick={handleOpen}>
                                                    <ICON_SEARCH />
                                                </Button>
                                                &nbsp;
                                                <Button key={selectedAccused.resultado?.length} variant="danger" size="sm" onClick={handleRemoveResult}>
                                                    <ICON_REMOVE />
                                                </Button>
                                            </>
                                :
                                    <>
                                        <Button variant="info" size="sm" onClick={handleOpenInfo}>
                                            <ICON_SEARCH />
                                        </Button>
                                    </>
                        :
                            null
                }

                <StateAccusedResultForm
                    accused = { selectedAccused }
                    audience = { audience }
                    handleClose = { handleClose }
                    setAccused = { setAccused }
                    show = { show }
                    tipos = { tipos }
                />

                <AccusedResultInfo
                    accused = { selectedAccused }
                    audience = { audience }
                    handleClose = { handleCloseInfo }
                    show = { showInfo }
                />

            </td>
        </tr>
    );
};

export default AccusedListRow;